import { Component, OnInit, HostBinding, HostListener, ElementRef } from '@angular/core'

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  resolve: (value: any) => any
  reject: (reason: any) => void

  disableCancel = false

  @HostBinding('style.display') display = 'none'

  @HostListener('window:keyup.esc', ['$event'])
  @HostListener('click', ['$event']) click (event: MouseEvent | KeyboardEvent) {
    //console.log('cancel ok', !this.disableCancel, event instanceof KeyboardEvent, event.target === this.elementRef.nativeElement)
    if (!this.disableCancel && (event instanceof KeyboardEvent || event.target === this.elementRef.nativeElement)) {
      this.cancel()
    }
  }

  constructor(
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
  }

  show () {
    return new Promise<any>((resolve, reject) => {
      setTimeout(() => this.display = 'block', 0)
      this.resolve = resolve
      this.reject = reject
    })
  }

  confirm (value: any) {
    this.hide()
    this.resolve(value)
  }

  cancel () {
    this.hide()
    this.reject('CANCEL')
  }

  hide () {
    this.display = 'none'
  }

}
